import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import { ConditionsList, WebserviceResponse } from '../../../../_shared/interfaces';
import { AlertService, ConditionStoreService, IAlertType } from '../../../../_shared/services';
import {ClrCommonFormsModule, ClrIconModule, ClrNumberInputModule} from "@clr/angular";
import { JsonPipe, NgIf } from "@angular/common";
import { ClarityIcons, floppyIcon } from "@cds/core/icon";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: 'app-edit-condition',
  standalone: true,
  imports: [
    ClrCommonFormsModule,
    ReactiveFormsModule,
    NgIf,
    ClrIconModule,
    JsonPipe,
    ClrNumberInputModule
  ],
  templateUrl: './edit-condition.component.html',
  styleUrl: './edit-condition.component.sass'
})

export class EditConditionComponent implements OnInit {
  public editConditionForm: FormGroup = new FormGroup({});
  conditions: ConditionsList[] = [];
  public devMode: boolean = false;

  @Input() editCondition: number = 0;
  @Input() editType: number = 0;
  @Output() updatedCondition = new EventEmitter();

  constructor(
    private condss: ConditionStoreService,
    private fb: FormBuilder,
    private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(floppyIcon);
    this.devMode = environment.stages.dev;
  }

  ngOnInit(): void {
    this.initForm();
    this.loadCondition(this.editCondition, this.editType);
  }

  initForm() {
    this.editConditionForm = this.fb.group({
      cond_id: [this.editCondition],
      cond_type: [this.editType],
      name: [''],
      text: [''],
      payment_term: [0],
      discount: [0],
      option: [false],
    });
  }

  loadCondition(conditionID: number, conditionType: number) {
    this.condss.getConditionById(conditionID, conditionType).subscribe({
      next: (data: WebserviceResponse<ConditionsList[]>) => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Condition konnte nicht geladen werden.',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.conditions = data.object;
        const condition = this.conditions[0];
        this.editConditionForm.patchValue({
          cond_id: condition.cond_id,
          cond_type: condition.cond_type,
          name: condition.name,
          text: condition.text,
          payment_term: condition.payment_term,
          discount: condition.discount,
          option: condition.option,
        });
      },
      error: () => {
        return
      }
    });
  }

  updateCondition() {
    const payload = {
      ...this.editConditionForm.value,
      cond_id: Number(this.editConditionForm.value?.cond_id ?? 0),
      cond_type: Number(this.editConditionForm.value?.cond_type ?? 0),
      payment_term: Number(this.editConditionForm.value?.payment_term ?? 0),
      discount: Number(this.editConditionForm.value?.discount ?? 0),
    };
    this.condss.updateCondition(payload).subscribe({
      next: (data: WebserviceResponse<ConditionsList[]>) => {
        if (!data || data.hasErrors) {
          this.alertDispatcher.show({
            message: ' Bedingung konnte nicht geändert werden.',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
          this.updatedCondition.emit(true);

      },
        error: () => {
        return
      }
    });
  }


  cancelEdit() {
    this.updatedCondition.emit(true);
  }
}
